<template>
  <div>
    <v-dialog v-model="hideShow" width="880px" persistent scrollable content-class="student-recharge-dialog" aria-label="学员缴费">
      <v-card class="sr-shell">
        <v-card-title class="sr-header">
          <span class="sr-symbol"><v-icon size="26" color="#d9363e">mdi-wallet-plus-outline</v-icon></span>
          <div><h2>学员缴费</h2><p>选择课程，核对缴费与账户增加信息</p></div>
          <v-spacer />
          <v-btn icon aria-label="关闭学员缴费" @click="cancel"><v-icon size="22">mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="sr-body">
          <div v-if="student" class="sr-student">
            <span class="sr-avatar"><v-icon size="23" color="#63748a">mdi-account-outline</v-icon></span>
            <div class="sr-student-name"><span>缴费学员</span><strong>{{student.studentName || '—'}}</strong></div>
            <div class="sr-student-no"><span>学号</span><strong>{{student.studentNo || '—'}}</strong></div>
          </div>

          <div class="sr-layout">
            <div class="sr-form">
              <section v-if="student" class="sr-section" aria-labelledby="sr-course-heading">
                <div class="sr-section-heading"><h3 id="sr-course-heading">课程与经办</h3></div>
                <div class="sr-fields">
                  <v-select class="sr-full" v-model="add.courseModel" :items="selectCourseList" label="缴费课程" placeholder="请选择缴费课程" item-text="courseName" item-value="id" return-object outlined dense hide-details color="#d9363e" @change="courseChanged" />
                  <v-select class="sr-full" v-model="add.priceModel" :disabled="!add.courseModel" :items="coursePriceList" label="价格套餐" placeholder="请选择价格套餐" item-text="viewText" item-value="id" return-object clearable outlined dense hide-details color="#d9363e" @change="priceChanged" no-data-text="暂无价格套餐数据" />
                  <v-select :items="selectTeacherList" v-model="add.order.salesTeacherId" item-text="trueName" item-value="id" label="开单老师" dense outlined clearable hide-details color="#d9363e" />
                  <v-select :items="selectTeacherList" v-model="add.order.classTeacherId" item-text="trueName" item-value="id" label="上课老师" dense outlined clearable hide-details color="#d9363e" />
                </div>
              </section>

              <section v-if="add.courseModel && add.courseModel.consumeType=='1'" class="sr-section" aria-labelledby="sr-hour-heading">
                <div class="sr-section-heading"><h3 id="sr-hour-heading">缴费内容</h3><span class="sr-mode">课时账户</span></div>
                <p class="sr-mode-note"><v-icon size="16">mdi-information-outline</v-icon>按课时扣费，每次上课扣除该课程的课时。</p>
                <div class="sr-fields">
                  <v-text-field label="课程原价" v-model="add.order.courseAmount" type="number" suffix="元" dense outlined hide-details color="#d9363e" />
                  <v-text-field label="增加课时" v-model="add.order.classHours" type="number" suffix="课时" dense outlined hide-details color="#d9363e" />
                  <v-select label="优惠券" placeholder="请选择优惠券" v-model="add.selectedCoupon" :items="studentCouponItems" item-text="couponName" item-value="id" no-data-text="没有可用优惠券" return-object clearable :disabled="!add.order.courseAmount" dense outlined hide-details color="#d9363e" @change="courseCouponChanged" />
                  <v-text-field label="优惠券金额" v-model="couponAmount" suffix="元" disabled dense outlined hide-details />
                  <v-text-field label="减免金额" v-model="add.order.reduceAmount" type="number" suffix="元" dense outlined hide-details color="#d9363e" />
                </div>
              </section>

              <section v-if="add.courseModel && add.courseModel.consumeType=='2'" class="sr-section" aria-labelledby="sr-cash-heading">
                <div class="sr-section-heading"><h3 id="sr-cash-heading">缴费内容</h3><span class="sr-mode">金额账户</span></div>
                <p class="sr-mode-note"><v-icon size="16">mdi-information-outline</v-icon>按金额扣费，每次上课扣除金额账户余额。</p>
                <div class="sr-fields">
                  <v-text-field label="缴费金额" v-model="add.order.cashAmount" type="number" suffix="元" dense outlined hide-details color="#d9363e" />
                  <v-text-field label="赠送金额" v-model="add.order.giveAmount" type="number" suffix="元" dense outlined hide-details color="#d9363e" />
                  <v-select label="优惠券" placeholder="请选择优惠券" v-model="add.selectedCoupon" :items="studentCouponItems" item-text="couponName" item-value="id" no-data-text="没有可用优惠券" return-object clearable :disabled="!add.order.cashAmount" dense outlined hide-details color="#d9363e" @change="cashCouponChanged" />
                  <v-text-field label="优惠券金额" v-model="couponAmount" suffix="元" disabled dense outlined hide-details />
                  <v-text-field label="增加总金额" v-model="totalTuitionFee" suffix="元" disabled dense outlined hide-details />
                </div>
              </section>

              <section v-if="add.courseModel && (add.courseModel.consumeType=='1' || add.courseModel.consumeType=='2')" class="sr-section" aria-labelledby="sr-payment-heading">
                <div class="sr-section-heading"><h3 id="sr-payment-heading">收款信息</h3></div>
                <div class="sr-fields">
                  <v-select v-model="add.order.payType" :items="payTypeList" label="付款方式" item-text="text" item-value="code" clearable outlined dense hide-details color="#d9363e" no-data-text="暂无付款方式" />
                  <v-text-field label="备注" placeholder="填写缴费备注（选填）" v-model="add.order.memo" dense outlined hide-details color="#d9363e" />
                </div>
              </section>
            </div>

            <aside class="sr-summary" aria-label="本次缴费汇总">
              <h3>本次缴费</h3>
              <template v-if="add.courseModel && (add.courseModel.consumeType=='1' || add.courseModel.consumeType=='2')">
                <p class="sr-summary-course">{{add.courseModel.courseName}}</p>
                <dl v-if="add.courseModel.consumeType=='1'" class="sr-breakdown">
                  <div><dt>课程原价</dt><dd>{{add.order.courseAmount || 0}}<span> 元</span></dd></div>
                  <div><dt>优惠券抵扣</dt><dd>− {{couponAmount}}<span> 元</span></dd></div>
                  <div><dt>减免金额</dt><dd>− {{add.order.reduceAmount || 0}}<span> 元</span></dd></div>
                </dl>
                <dl v-else class="sr-breakdown">
                  <div><dt>缴费金额</dt><dd>{{add.order.cashAmount || 0}}<span> 元</span></dd></div>
                  <div><dt>优惠券抵扣</dt><dd>− {{couponAmount}}<span> 元</span></dd></div>
                </dl>
                <div class="sr-due" aria-live="polite">
                  <span>应付金额</span>
                  <div><small>¥</small><strong>{{add.courseModel.consumeType=='1' ? courseRealPayFee : cashRealPayFee}}</strong></div>
                </div>
                <div class="sr-credit" v-if="add.courseModel.consumeType=='1'"><span>本次增加</span><strong>{{add.order.classHours || 0}}<small> 课时</small></strong></div>
                <template v-else>
                  <div class="sr-credit"><span>本次增加</span><strong>{{totalTuitionFee}}<small> 元</small></strong></div>
                  <p class="sr-gift">含赠送金额 {{add.order.giveAmount || 0}} 元</p>
                </template>
              </template>
              <div v-else class="sr-summary-empty"><v-icon size="36">mdi-receipt-text-outline</v-icon><p>选择缴费课程后<br>在这里核对金额与账户增加信息</p></div>
            </aside>
          </div>
        </v-card-text>

        <v-card-actions class="sr-footer">
          <span class="sr-footer-note">请核对缴费信息后确认</span>
          <v-spacer />
          <v-btn outlined color="#586a80" @click="cancel">取消</v-btn>
          <v-btn depressed color="#d9363e" dark @click="submitOrder" :loading="add.submitLoadding">确认缴费</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
	import utils from "../config/utils.js"
	export default {
		name:"student-recharge",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			student:{
				type:Object,
				default:null
			},
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					// 显示组件时
					this.clearAdd();
					
					// 加载课程
					this.getCourseListForSelect();
					// 加载优惠券
					this.getStudentCouponListForSelect();
				}
			}
		},
		computed:{
			cashRealPayFee(){
				if(!this.add.order.cashAmount){
					return "0";
				}
				
				let orderAmount = parseFloat(this.add.order.cashAmount);
				let couponAmount = 0;
				if (this.add.selectedCoupon){
					couponAmount = parseFloat(this.add.selectedCoupon.amount);
				}
		
				let result = orderAmount - couponAmount;
		
				return result > 0 ? result:0 ;
			},
			courseRealPayFee(){
				if(!this.add.order.courseAmount){
					return "0";
				}
				
				let orderAmount = parseFloat(this.add.order.courseAmount);
				let couponAmount = 0;
				// 优惠券减
				if (this.add.selectedCoupon){
					couponAmount = parseFloat(this.add.selectedCoupon.amount);
				}
				// 直减
				let reduceAmount = 0
				if (this.add.order.reduceAmount){
					reduceAmount = parseFloat(this.add.order.reduceAmount);
				}
				
				let result = orderAmount - couponAmount - reduceAmount;
			
				return result > 0 ? result:0 ;
			},
			totalTuitionFee(){
				let cashAmount = 0;
				if(this.add.order.cashAmount){
					cashAmount = parseFloat(this.add.order.cashAmount);
				}
				let giveAmount = 0;
				if(this.add.order.giveAmount){
					giveAmount = parseFloat(this.add.order.giveAmount);
				}
				
				let result =  cashAmount + giveAmount;
				
				return result.toString();
			},
			couponAmount(){
				if(!this.add.selectedCoupon){
					return "0";
				}
				
				return this.add.selectedCoupon.amount;
			},
			courseDisabled(){
				let result = false;
				if (this.add.priceModel){
					if(this.add.priceModel.consumeType =="1"){
						result = true;
					}
				}
				
				return result;
			},
			cashDisabled(){
				let result = false;
				if (this.add.priceModel){
					if(this.add.priceModel.consumeType =="2"){
						result = true;
					}
				}
				
				return result;
			}
		},
		data(){
			return {
				add: {
					submitLoadding:false,
					courseModel:null,
					selectedCoupon:null,
					priceModel:null,
					order: {
						cashAmount:"",
						giveAmount:"",
						courseAmount:"",
						classHours:"",
						reduceAmount:"",
						memo:"",
						payType:"",
						salesTeacherId:"",
						classTeacherId:""
					},
				},
				shopId:"",
				selectTeacherList: [], //选择老师数据源
				selectCourseList:[],// 课程数据源
				studentCouponItems:[], //优惠券数据源
				hideShow:this.show,
				coursePriceList:[], //课程价格套餐
				payTypeList:[
					{code:'ALIPAY',text:'支付宝'},
					{code:'WXPAY',text:'微信'},
					{code:'CASH',text:'现金'},
				],
			}
		},
		mounted() {
			console.log("student-recharge mounted");
			
			this.shopId = utils.getCurrentShopId(); 
			
			this.getTeacherListForSelect();
		},
		methods:{
			clearAdd(){
				this.add.courseModel = null;
				this.add.order.cashAmount = "";
				this.add.order.giveAmount = "";
				this.add.order.courseAmount = "";
				this.add.order.classHours = "";
				this.add.order.memo = "";
				this.add.selectedCoupon = null;
				this.add.order.reduceAmount = "";
				this.add.order.payType = "";
				this.add.order.salesTeacherId = "";
				this.add.order.classTeacherId = "";
				
				// 课程价格
				this.coursePriceList = [];
			},
			cancel(){
				this.$emit("cancel","");
			},
			courseChanged(e){
				// 选择的课程变了 
				console.log(e);
				
				this.add.priceModel = null; // 未选中价格对象
				this.coursePriceList = [];  // 套餐列表清空
				
				this.add.order.courseAmount = "";
				this.add.order.classHours = "";
				this.add.order.reduceAmount = "";
				this.add.order.cashAmount = "";
				this.add.order.giveAmount = "";
				// 获取课程价格模板
				this.getCoursePriceListForSelect();
			},
			priceChanged(e){
				// 选择了套餐价格
				console.log(e);
				if (e){
					if (e.consumeType == '1'){
						this.add.order.courseAmount = e.courseAmount;
						this.add.order.classHours = e.addHours;
						this.add.order.reduceAmount = e.reduceAmount;
					}else if(e.consumeType == '2'){
						this.add.order.cashAmount = e.courseAmount;
						this.add.order.giveAmount = e.giveAmount;
					}
					
				}else{
					this.add.order.courseAmount = "";
					this.add.order.classHours = "";
					this.add.order.reduceAmount = "";
					this.add.order.cashAmount = "";
					this.add.order.giveAmount = "";
				}
			},
			cashCouponChanged(e){
				console.log(e);
				// 学费 优惠券选择
				let limitAmount = parseFloat(e.limitAmount);
				const cashAmount = parseFloat(this.add.order.cashAmount);
				if (limitAmount > 0){
					// 有金额限制 判断金额限制
					if (cashAmount < limitAmount){
						// 不符合
						
						this.$noty.error('优惠券需满'+limitAmount+'元才能使用');
						const that = this;
						setTimeout(()=>{
							that.add.selectedCoupon = null;
						},100)
					}
				}
				
			},
			courseCouponChanged(e){

				// 课时 优惠券选择
				let limitAmount = parseFloat(e.limitAmount);
				const cashAmount = parseFloat(this.add.order.courseAmount);
				if (limitAmount > 0){
					// 有金额限制 判断金额限制
					if (cashAmount < limitAmount){
						// 不符合
						
						this.$noty.error('优惠券需满'+limitAmount+'元才能使用');
						const that = this;
						setTimeout(()=>{
							that.add.selectedCoupon = null;
						},100)
					}
				}
				
			},
			submitOrder(){
				
				if(!this.add.courseModel || !this.add.courseModel.id){
					this.$noty.error('请选择课程');
					return;
				}
				const consumeType = this.add.courseModel.consumeType;
				if (consumeType == '1'){
					if(!this.add.order.courseAmount){
						this.$noty.error('请输入缴费金额');
						return;
					}
					
					// 判断正2位小数金额
					const isFloat = utils.isDecimal(this.add.order.courseAmount);
					if (!isFloat){
						this.$noty.error('请输入最多2位小数的金额');
						return;
					}
					
					if(!this.add.order.classHours){
						this.$noty.error('请输入课时数');
						return;
					}
					
					if(!utils.isInt(this.add.order.classHours)){
						this.$noty.error('课时只能输入正整数');
						return;
					}
					
				}else if (consumeType == '2'){
					if(!this.add.order.cashAmount){
						this.$noty.error('请输入缴费金额');
						return;
					}
					const isFloat = utils.isDecimal(this.add.order.cashAmount);
				
					if (!isFloat){
						this.$noty.error('请输入最多2位小数的金额');
						return;
					}
				}
				this.add.submitLoadding = true;
				let postData = {
					studentId:this.student.id,
					courseId:this.add.courseModel.id,
					consumeType:consumeType,
					cashAmount:this.add.order.cashAmount,
					giveAmount:this.add.order.giveAmount,
					courseAmount:this.add.order.courseAmount,
					classHours:this.add.order.classHours,
					reduceAmount:this.add.order.reduceAmount,
					memo:this.add.order.memo,
					payType:this.add.order.payType,
					salesTeacherId:this.add.order.salesTeacherId,
					classTeacherId:this.add.order.classTeacherId
					
				}
				if(this.add.selectedCoupon){
					postData.studentCouponId = this.add.selectedCoupon.id;
				}
				if (this.add.priceModel){
					postData.priceId = this.add.priceModel.id;
				}
				
				// api
				const that = this;
				let url = `/financial/student/recharge`;
				
				this.axios.post(url, postData).catch(() => {
					that.add.submitLoadding = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.add.submitLoadding = false;
							that.$noty.success("添加成功");
							
							// 提交成功
							that.$emit("success","");
							
							return;
						} else {
							that.add.submitLoadding = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submitLoadding = false;
						that.$noty.error('网络请求失败');
					}
				
				});
				
				
				
			},
			getCourseListForSelect() {
			
				const shopId = this.student.shopId;
				
				if (!shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/course/list/` + shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						
						let cList = response.data["data"] ? response.data["data"] : [];
						
						console.log(cList);
						
			
						that.selectCourseList = cList.filter(item => item.status === '1')
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getStudentCouponListForSelect() {
				// 获取学生优惠券
				const studentId = this.student.id;
				if (!studentId) {
					return
				}
				const that = this;
				let url = `/financial/student/all/coupon/list/` + studentId;
			
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						console.log(">>>>>>>>>获取学员优惠券 start>>>>>>>>>")
						
						console.log("url:",url);
						console.log("res:",response.data);
						
						console.log(">>>>>>>>>获取学员优惠券 end>>>>>>>>>")
						
						that.studentCouponItems = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getCoursePriceListForSelect() {
				
				// 获取课程价格套餐
				
				const courseId = this.add.courseModel.id;
				
				if (!courseId) {
					return
				}
				
				const that = this;
				let url = `/financial/course/${courseId}/available/price/list`;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.coursePriceList = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getTeacherListForSelect() {
			
				if (!this.shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/teacher/list/` + this.shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.selectTeacherList = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
	
</script>

<style lang="scss" scoped src="../assets/styles/student-recharge.scss"></style>
